import { render, staticRenderFns } from "./OrganizationTabFederation.vue?vue&type=template&id=6a6a3536&scoped=true"
import script from "./OrganizationTabFederation.vue?vue&type=script&lang=js"
export * from "./OrganizationTabFederation.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTabFederation.vue?vue&type=style&index=0&id=6a6a3536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a3536",
  null
  
)

export default component.exports